import { PlanConfigByStepComponent } from "../components";
import { connect } from "react-redux";
import { GetDataPlanConfigByStepPlanTemplateAction, SetDataPlanConfigByStepPlanTemplateAction } from "../actions";
import { GetDataLayoutLayoutAction } from "../../Layout/actions";

const mapStateToProps = state => {
    return {
        ...state,
        DataPlanConfigByStep: state.allPlanTemplateReducers.planConfigByStepReducer.DataPlanConfigByStep,
        isResult: state.allPlanTemplateReducers.isResultReducer.isResult
    };
};

const mapDispatchToProps = dispatch => {
    return {
        GetDataPlanConfigByStep: (id, stepNumberPerform) => {
            dispatch(GetDataPlanConfigByStepPlanTemplateAction(id, stepNumberPerform));
        },
        SetDataPlanConfigByStep: (DataPlanConfigByStep) => {
            dispatch(SetDataPlanConfigByStepPlanTemplateAction(DataPlanConfigByStep));
        },
        GetDataLayout: () => {
            dispatch(GetDataLayoutLayoutAction());
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PlanConfigByStepComponent);